// src/context/CartContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import * as CartService from "../services/CartService";

const CartContext = createContext();

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
    const [cartItems, setCartItems] = useState([]);

    useEffect(() => {
        setCartItems(CartService.getCart());
    }, []);

    const addItem = (product, qty = 1) => {
        const updatedCart = CartService.addToCart(product, qty);
        setCartItems(updatedCart);
    };

    const updateItem = (slug, qty, color, size) => {
        const updatedCart = CartService.updateCartItem(slug, qty, color, size);
        setCartItems(updatedCart);
    };

    const removeItem = (slug, color, size) => {
        const updatedCart = CartService.removeCartItem(slug, color, size);
        setCartItems(updatedCart);
    };

    const clearAll = () => {
        CartService.clearCart();
        setCartItems([]);
    };

    const isInCart = (slug, color, size) => {
        return cartItems.some(
            item =>
                item.slug === slug &&
                item.color === color &&
                item.size === size
        );
    };

    const subtotal = cartItems.reduce((acc, item) => acc + item.price * item.qty, 0);

    return (
        <CartContext.Provider
            value={{ cartItems, addItem, updateItem, removeItem, clearAll, isInCart, subtotal }}
        >
            {children}
        </CartContext.Provider>
    );
};
